// extracted by mini-css-extract-plugin
export default {"keywordsSection":"Keywords_keywordsSection__8OrOr","keywordWrapper":"Keywords_keywordWrapper__pd6sq"};